__webpack_require__.p = "https://staticfiles.nb-sandbox.com/foodradar-website-prod/_next/";